// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";


// import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDiasI5IqpZRxjCP_TUZqmvFmUfH6ENQDk",
  authDomain: "focusinspectiontechnolog-2caef.firebaseapp.com",
  projectId: "focusinspectiontechnolog-2caef",
  storageBucket: "focusinspectiontechnolog-2caef.firebasestorage.app",
  messagingSenderId: "27019395658",
  appId: "1:27019395658:web:6ffa48207fdc76b0799cb3"
};

const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
const auth = getAuth(app);
const db = getFirestore(app);

const storage = getStorage(app);

export { auth, db, storage, collection, addDoc, ref, uploadBytes, getDownloadURL, firebaseConfig };
// Export auth and db for use in other parts of the app
// export const db = getFirestore(app);
